import React from "react";

const PastChanges = () => {
    return (
        <div>
            Past Changes
        </div>
    );
}

export default PastChanges;